import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { AuthLayout } from "components/Layouts/AuthLayout/AuthLayout.tsx";
import { getSessionFromStorage } from "hooks/useSession";

export const Route = createFileRoute("/auth/_layout")({
    component: AuthLayoutComponent,
    beforeLoad: () => {
        // Redirect to dashboard before rendering the login form, if user is already logged in -> tenant will be loaded
        if (getSessionFromStorage().token) {
            throw redirect({ to: "/", replace: true });
        }
    },
});

function AuthLayoutComponent() {
    return (
        <AuthLayout>
            <Outlet />
        </AuthLayout>
    );
}
